export const LOCAL_STORAGE_USER = 'techgo:user'

export type H3User = {
    token: string
    user_id: string
    type: string
    roles?: string[]
    permissions: string[]
    truck?: string
    full_name: string
    mobile: string | null
    clocked_in: string | null
}
